export const ENTRIES = [
{
    name: "Megan Eggert",
    golfers: [
        "Xander Schauffele",
        "Jon Rahm",
        "Rory McIlroy",
        "Justin Thomas",
        "Cameron Smith"
    ],
    tiebreaker: -13,
    },
{
    name: "Ray DelFava",
    golfers: [
        "Jon Rahm",
        "Cameron Smith",
        "Viktor Hovland",
        "Will Zalatoris",
        "Justin Thomas"
    ],
    tiebreaker: -13
    },
{
    name: "Matt Siebert",
    golfers: [
        "Scottie Scheffler",
        "Jon Rahm",
        "Collin Morikawa",
        "Viktor Hovland",
        "Patrick Cantlay"
    ],
    tiebreaker: -8
    },
{
    name: "George Eggert",
    golfers: [
        "Collin Morikawa",
        "Jon Rahm",
        "Xander Schauffele",
        "Justin Thomas",
        "Jordan Spieth"],
    tiebreaker: -9
    },
{
    name: "Rob Lantz",
    golfers: [
        "Dustin Johnson",
        "Collin Morikawa",
        "Cameron Smith",
        "Xander Schauffele",
        "Scottie Scheffler"
    ],
    tiebreaker: -11
    },
{
    name: "Al Shapiro",
    golfers: [
        "Patrick Cantlay",
        "Tommy Fleetwood",
        "Cameron Smith",
        "Viktor Hovland",
        "Brian Harman"
    ],
    tiebreaker: -13
    },
{
    name: "Ron Fortman #2",
    golfers: [
        "Justin Thomas",
        "Scottie Scheffler",
        "Viktor Hovland",
        "Adam Scott",
        "Will Zalatoris"
    ],
    tiebreaker: -12
    },
{
    name: "Ernie Cervantes",
    golfers: [
        "Jon Rahm",
        "Justin Thomas",
        "Cameron Smith",
        "Will Zalatoris",
        "Matthew Fitzpatrick"
    ],
    tiebreaker: -10
    },
{
    name: "Forrest Nelson",
    golfers: [
        "Scottie Scheffler",
        "Cameron Smith",
        "Collin Morikawa",
        "Justin Thomas",
        "Sam Burns"
    ],
    tiebreaker: -9
    },
{
    name: "Matt Majeski",
    golfers: [
        "Max Homa",
        "Collin Morikawa",
        "Scottie Scheffler",
        "Jordan Spieth",
        "Tommy Fleetwood"
    ],
    tiebreaker: -11
    },
{
    name: "Jeff Nelson",
    golfers: [
        "Justin Thomas",
        "Brooks Koepka",
        "Cameron Smith",
        "Xander Schauffele",
        "Will Zalatoris"
    ],
    tiebreaker: -5
    },
{
    name: "Karl Stevens #1",
    golfers: [
        "Scottie Scheffler",
        "Justin Thomas",
        "Jon Rahm",
        "Xander Schauffele",
        "Kevin Kisner"
    ],
    tiebreaker: -16
    },
{
    name: "Donoghue",
    golfers: [
        "Justin Thomas",
        "Brooks Koepka",
        "Xander Schauffele",
        "Dustin Johnson",
        "Jon Rahm"
    ],
    tiebreaker: -12
    },
{
    name: "Julie Majeski",
    golfers: [
        "Cameron Smith",
        "Jordan Spieth",
        "Jon Rahm",
        "Justin Thomas",
        "Will Zalatoris"
    ],
    tiebreaker: -10
    },
{
    name: "David Hess",
    golfers: [
        "Rory McIlroy",
        "Jon Rahm",
        "Justin Thomas",
        "Cameron Smith",
        "Brooks Koepka"
    ],
    tiebreaker: -14
    },
{
    name: "Roger VanWazer",
    golfers: [
        "Will Zalatoris",
        "Xander Schauffele",
        "Jordan Spieth",
        "Justin Thomas",
        "Corey Conners"
    ],
    tiebreaker: -8
    },
{
    name: "Connie Wade",
    golfers: [
        "Justin Thomas",
        "Cameron Smith",
        "Scottie Scheffler",
        "Collin Morikawa",
        "Xander Schauffele"
    ],
    tiebreaker: -11
    },
{
    name: "Brian Wade",
    golfers: [
        "Jon Rahm",
        "Rory McIlroy",
        "Brooks Koepka",
        "Will Zalatoris",
        "Adam Scott"
    ],
    tiebreaker: -11
    },
{
    name: "Tom Arndt",
    golfers: [
        "Cameron Smith",
        "Brooks Koepka",
        "Jordan Spieth",
        "Justin Thomas",
        "Rory McIlroy"
    ],
    tiebreaker: -12
    },
{
    name: "Ron Fortman #1",
    golfers: [
        "Justin Thomas",
        "Jon Rahm",
        "Dustin Johnson",
        "Patrick Cantlay",
        "Cameron Smith"
    ],
    tiebreaker: -12
    },
{
    name: "Bob Chuchill",
    golfers: [
        "Scottie Scheffler",
        "Justin Thomas",
        "Jon Rahm",
        "Tony Finau",
        "Xander Schauffele"
    ],
    tiebreaker: -13
    },
{
    name: "Tony Fasuna",
    golfers: [
        "Jon Rahm",
        "Dustin Johnson",
        "Cameron Smith",
        "Justin Thomas",
        "Scottie Scheffler"
    ],
    tiebreaker: -13
    },
{
    name: "Nick Pantaleo",
    golfers: [
        "Collin Morikawa",
        "Justin Thomas",
        "Jon Rahm",
        "Viktor Hovland",
        "Xander Schauffele"
    ],
    tiebreaker: -9
    },
{
    name: "Pete Majeski",
    golfers: [
        "Brooks Koepka",
        "Xander Schauffele",
        "Shane Lowry",
        "Tyrrell Hatton",
        "Rory McIlroy"
    ],
    tiebreaker: -13
    },
{
    name: "Dan Hotchkin",
    golfers: [
        "Jon Rahm",
        "Justin Thomas",
        "Brooks Koepka",
        "Cameron Smith",
        "Collin Morikawa"
    ],
    tiebreaker: -9
    },
{
    name: "Billy Pitcher",
    golfers: [
        "Brooks Koepka",
        "Scottie Scheffler",
        "Cameron Smith",
        "Jordan Spieth",
        "Tyrrell Hatton"
    ],
    tiebreaker: -13
    },
{
    name: "Karl Stevens #2",
    golfers: [
        "Dustin Johnson",
        "Cameron Smith",
        "Patrick Cantlay",
        "Corey Conners",
        "Viktor Hovland"
    ],
    tiebreaker: -16
    },
{
    name: "Nick Morini",
    golfers: [
        "Justin Thomas",
        "Jon Rahm",
        "Brooks Koepka",
        "Viktor Hovland",
        "Cameron Smith"
    ],
    tiebreaker: -13
    },
{
    name: "Cam Majeski",
    golfers: [
        "Sam Burns",
        "Jon Rahm",
        "Brooks Koepka",
        "Scottie Scheffler",
        "Cameron Smith"
    ],
    tiebreaker: -12
    },
{
    name: "Carmardo",
    golfers: [
        "Justin Thomas",
        "Xander Schauffele",
        "Jon Rahm",
        "Jordan Spieth",
        "Tiger Woods"
    ],
    tiebreaker: -8
    },
]